import {useInView} from './useInViewHook'
export default function Card({ title, description, icon }) {
  const [ref,visible] = useInView();
  return (
    <div ref={ref} className={`font-[Passero_One] bg-black text-white rounded-3xl p-8 flex flex-col gap-4 hover:scale-[1.02] transition-transform duration-200 dark:bg-white dark:text-black ${visible ? "slide" : "translate-y-16"} `}>

      {/* Icon */}
      {icon && (
        <div className="text-3xl dark:invert">
           <img alt="heh" src={icon}/>
        </div>
      )}

      {/* Title */}
      <h3 className="text-3xl font-bold">
        {title}
      </h3>

      {/* Description */}
      <p className="text-gray-300 leading-relaxed dark:invert">
        {description}
      </p>
      
    </div>
  );
}